import React from 'react';

import SEO from '../components/layout/seo';
import Navigation from '../components/sections/cycle/Navigation';
import SectionHero from '../components/pagebuilder/section-hero';

const NotFoundPage = ({ data }) => {
  return (
    <>
      <Navigation />
      <SectionHero />
      <SEO title="404: Not found" />
      <main style={{ textAlign: 'center', maxWidth: '500px', margin: '2em auto 4em' }}>
        <h1>Whoops, page not found</h1>
        <br />
        <p>Please use the links in the side menu to find what you are looking for.</p>
        <br />
      </main>
    </>
  );
};

export default NotFoundPage;
